// extracted by mini-css-extract-plugin
module.exports = {"base":"pageNotFound_base__b9Ni5","messageTitle":"pageNotFound_messageTitle__3rYbe","message":"pageNotFound_message__2Nt-n","link":"pageNotFound_link__3Uon2"};